const getFirstImageAsset = (image) => Array.isArray(image) ? image.find(({ url }) => Boolean(url)) ?? null : null;
const replaceTemplateStrings = (template, templateVariables) => {
  return template.replace(/\{(\w+)\}/g, (_, key) => {
    if (Object.prototype.hasOwnProperty.call(templateVariables, key)) {
      return templateVariables[key] ?? "";
    }
    return "";
  });
};
const isComposableWindowTextOnlyObject = (obj) => {
  const textOnly = obj.text_only;
  return (textOnly == null ? void 0 : textOnly.development_field_key) !== void 0;
};
const isComposableWindowTextWithImagesObject = (obj) => {
  const text_with_images = obj.text_with_images;
  return (text_with_images == null ? void 0 : text_with_images.development_key) !== void 0;
};
const findTextBodyByDevFieldKey = (composableWindow, key) => {
  for (const item of composableWindow) {
    if (isComposableWindowTextOnlyObject(item) && item.text_only.development_field_key === key) {
      return item.text_only.body;
    } else if (isComposableWindowTextWithImagesObject(item) && item.text_with_images.development_key === key) {
      return item.text_with_images.body;
    }
  }
  return void 0;
};
const getComposableTextByDevFieldKey = ({
  devFieldKey,
  composableWindow,
  templateVariables
}) => {
  const templateText = findTextBodyByDevFieldKey(
    composableWindow,
    devFieldKey
  );
  const finalizedText = replaceTemplateStrings(
    templateText ?? "",
    templateVariables
  );
  return finalizedText;
};
const isFeatureEnabledForApplication = (featureToggle, enabledApplications) => {
  const isEnabled = enabledApplications == null ? void 0 : enabledApplications.filter(
    (entry) => {
      var _a;
      return featureToggle && process.env.NEXT_PUBLIC_SITE && (entry == null ? void 0 : entry.includes((_a = process.env.NEXT_PUBLIC_SITE) == null ? void 0 : _a.toLowerCase()));
    }
  );
  return isEnabled && isEnabled.length > 0 ? true : false;
};
export {
  findTextBodyByDevFieldKey,
  getComposableTextByDevFieldKey,
  getFirstImageAsset,
  isComposableWindowTextOnlyObject,
  isComposableWindowTextWithImagesObject,
  isFeatureEnabledForApplication,
  replaceTemplateStrings
};
